export const translations = {
  en: {
    nav: {
      about: "01.About",
      skills: "02.Skills",
      experience: "03.Experience",
      projects: "04.Projects",
      achievements: "05.Achievements",
      contact: "06.Contact"
    },
    hero: {
      title: "Hi, I'm Selin Çifci",
      subtitle: "Frontend Developer",
      description: "I create beautiful and functional web experiences with modern technologies.",
      downloadCV: "Download CV",
      contactMe: "Contact Me"
    },
    about: {
      title: "About Me",
      description: "My interest in mobile development started during my university education, where I studied in English and explored emerging technologies. I began with React Native and later expanded into Flutter and native Android development using Kotlin and Jetpack Compose, building applications across multiple platforms. Over time, this evolved into a passion for developing intuitive and scalable mobile applications.",
      description2: "Since then, I have had the opportunity to collaborate with people from diverse backgrounds, which strengthened my teamwork and problem-solving skills. Currently, I focus on creating user-friendly, accessible, and impactful mobile experiences that make a difference in people's lives. Outside of coding, I enjoy cycling and listening to podcasts."
    },
    skills: {
        title: "Skills",
        subtitle: "Technologies and tools I work with",
        categories: {
          "Frontend Development": "Frontend Development",
          "Database": "Database",
          "Mobile Development": "Mobile Development",
          "Tools & Platforms": "Tools & Platforms"
        }
      },
      experience: {
        title: "Experience",
        subtitle: "Where I've Worked"
      },
      works: {
        title: "Projects",
        viewProject: "View Project",
        projects: [
          {
            title: "Team Management System",
            description: "Mobile app for Kapsül Technology Platform - teams can apply for competitions and request materials/products."
          },
          {
            title: "FlowPass",
            description: "Blockchain-powered urban transportation payment app with stablecoin micro-payments and decentralized identity."
          },
          {
            title: "RouteAI",
            description: "AI-powered travel guide mobile app with personalized recommendations using Gemini AI."
          },
          {
            title: "MIPS Assembly Simulator",
            description: "Interactive web-based IDE for MIPS assembly programming with real-time memory visualization."
          }
        ]
      },
      achievements: {
        title: "Achievements"
      },
      contact: {
        title: "Contact",
        email: "Email",
        address: "Address",
        addressValue: "İhsaniye, Derviş Hilmi Sk. No:2/D, 42060 Selçuklu/Konya",
        name: "Your Name",
        emailPlaceholder: "Your Email Address",
        subject: "Subject",
        message: "Your Message",
        sendMessage: "Send Message",
        successMessage: "Your message has been sent successfully! 🎉",
        errorMessage: "An error occurred while sending the message. Please try again."
      }
    },
    tr: {
      nav: {
        about: "01.Hakkımda",
        skills: "02.Yetenekler",
        experience: "03.Deneyim",
        projects: "04.Projeler",
        achievements: "05.Başarılar",
        contact: "06.İletişim"
      },
      hero: {
        title: "Merhaba, Ben Selin Çifci",
        subtitle: "Frontend Geliştirici",
        description: "Modern teknolojilerle güzel ve işlevsel web deneyimleri yaratıyorum.",
        downloadCV: "CV İndir",
        contactMe: "İletişime Geç"
      },
      about: {
        title: "Hakkımda",
        description: "Mobil geliştirmeye ilgim, üniversitede %100 İngilizce aldığım eğitim sırasında yeni teknolojileri keşfetmemle başladı. React Native ile başladığım bu yolculukta zamanla Flutter ve native Android tarafında Kotlin ve Jetpack Compose kullanarak farklı platformlarda uygulamalar geliştirdim. Bu süreç, sezgisel ve ölçeklenebilir mobil uygulamalar geliştirme tutkusuna dönüştü.",
        description2: "O zamandan beri farklı alanlardan insanlarla birlikte çalışma fırsatı buldum; bu da takım çalışması ve problem çözme becerilerimi güçlendirdi. Şimdi ise insanların hayatına dokunan, kullanıcı dostu ve erişilebilir mobil deneyimler tasarlamaya odaklanıyorum. Kodlamanın dışında ise bisiklet sürmekten ve podcast dinlemekten keyif alırım."
      },
      skills: {
        title: "Yetenekler",
        subtitle: "Çalıştığım teknolojiler ve araçlar",
        categories: {
          "Frontend Development": "Frontend Geliştirme",
          "Database": "Veritabanı",
          "Mobile Development": "Mobil Geliştirme",
          "Tools & Platforms": "Araçlar & Platformlar"
        }
      },
      experience: {
        title: "Deneyimlerim",
        subtitle: "Çalıştığım Yerler"
      },
      works: {
        title: "Projelerim",
        viewProject: "Projeyi Gör",
        projects: [
          {
            title: "Team Management System",
            description: "Kapsül Teknoloji Platformu mobil uygulaması - takımlar yarışmalara başvurabilir ve malzeme/ürün talebinde bulunabilir."
          },
          {
            title: "FlowPass",
            description: "Blockchain destekli şehir içi ulaşım ödeme uygulaması - stablecoin mikro ödemeler ve merkeziyetsiz kimlik."
          },
          {
            title: "RouteAI",
            description: "Gemini AI ile kişiselleştirilmiş öneriler sunan akıllı seyahat rehberi mobil uygulaması."
          },
          {
            title: "MIPS Assembly Simulator",
            description: "Gerçek zamanlı bellek görselleştirmesi ile MIPS assembly programlama için interaktif web tabanlı IDE."
          }
        ]
      },
      achievements: {
        title: "Başarılar"
      },
      contact: {
        title: "İletişim",
        email: "Email",
        address: "Adres",
        addressValue: "İhsaniye, Derviş Hilmi Sk. No:2/D, 42060 Selçuklu/Konya",
        name: "Adınız",
        emailPlaceholder: "Email Adresiniz",
        subject: "Konu",
        message: "Mesajınız",
        sendMessage: "Mesaj Gönder",
        successMessage: "Mesajınız başarıyla gönderildi! 🎉",
        errorMessage: "Mesaj gönderilirken bir hata oluştu. Lütfen tekrar deneyin."
      }
    }
  }; 